export const AUDIT_HISTORIES_LINK_LABEL = "Audit histories";

export const AUDIT_HISTORIES_LINK_TARGET = "_blank";
export const AUDIT_HISTORIES_LINK_REL = "noopener noreferrer";

export const AUDIT_ENTITY_CONFIG = {
  product: { entityType: "PRODUCT", label: "Product" },
  customer: { entityType: "CUSTOMER", label: "Customer" },
  "customer-type": { entityType: "CUSTOMER_TYPE", label: "Customer type" },
  supplier: { entityType: "SUPPLIER", label: "Supplier" },
  user: { entityType: "USER", label: "User" },
  allergen: { entityType: "ALLERGEN", label: "Allergen" },
  "box-type": { entityType: "BOX_TYPE", label: "Box type" },
  carrier: { entityType: "CARRIER", label: "Carrier" },
  category: { entityType: "CATEGORY", label: "Category" },
  class: { entityType: "CLASS", label: "Class" },
  currency: { entityType: "CURRENCY", label: "Currency" },
  graphic: { entityType: "GRAPHIC", label: "Graphic" },
  "inventory-type": { entityType: "INVENTORY_TYPE", label: "Inventory type" },
  location: { entityType: "LOCATION", label: "Location" },
  "reason-code": { entityType: "REASON_CODE", label: "Reason code" },
  warehouse: { entityType: "WAREHOUSE", label: "Warehouse" },
  "warehouse-location": {
    entityType: "WAREHOUSE_LOCATION",
    label: "Warehouse location",
  },
  station: { entityType: "STATION", label: "Station" },
  "tax-rate": { entityType: "TAX_RATE", label: "Tax rate" },
  laboratory: { entityType: "LABORATORY", label: "Laboratory" },
  "lab-sample": { entityType: "LAB_SAMPLE", label: "Lab sample" },
  "product-colour": { entityType: "PRODUCT_COLOUR", label: "Product colour" },
  "product-odour": { entityType: "PRODUCT_ODOUR", label: "Product odour" },
  "product-taste": { entityType: "PRODUCT_TASTE", label: "Product taste" },
  "spec-sheet-test": {
    entityType: "SPEC_SHEET_TEST",
    label: "Spec sheet test",
  },
  order: { entityType: "ORDER", label: "Order" },
  "order-item": { entityType: "ORDER_ITEM", label: "Order item" },
  "receiving-invoice": {
    entityType: "RECEIVING_INVOICE",
    label: "Receiving invoice",
  },
  "receiving-item": { entityType: "RECEIVING_ITEM", label: "Receiving item" },
  "receiving-truck": {
    entityType: "RECEIVING_TRUCK",
    label: "Receiving truck",
  },
  "credit-return": { entityType: "CREDIT_RETURN", label: "Credit return" },
  "credit-return-item": {
    entityType: "CREDIT_RETURN_ITEM",
    label: "Credit return item",
  },
  wip: { entityType: "WIP", label: "WIP" },
  "wip-item": { entityType: "WIP_ITEM", label: "WIP item" },
  "wip-room": { entityType: "WIP_ROOM", label: "WIP room" },
  "manufactured-product": {
    entityType: "MANUFACTURED_PRODUCT",
    label: "Manufactured product",
  },
  pallet: { entityType: "PALLET", label: "Pallet" },
  "cycle-count": { entityType: "CYCLE_COUNT", label: "Cycle count" },
  "cycle-count-item": {
    entityType: "CYCLE_COUNT_ITEM",
    label: "Cycle count item",
  },
};

export function getAuditEntityConfig(slug) {
  if (!slug) return null;
  return AUDIT_ENTITY_CONFIG[String(slug).toLowerCase()] ?? null;
}

export function getAuditApiEntityType(slug) {
  return AUDIT_ENTITY_CONFIG[slug]?.entityType ?? null;
}

export function buildAuditUrl(slug, id, name) {
  const encodedName = encodeURIComponent(name ?? "");
  return `/audit/${slug}/${id}?name=${encodedName}`;
}

export function buildAuditHistoriesUrl(slug) {
  return `/audit-histories/${slug}`;
}

export function auditHistoriesSetupAction(slug) {
  return {
    label: AUDIT_HISTORIES_LINK_LABEL,
    href: buildAuditHistoriesUrl(slug),
    variant: "gray",
    target: AUDIT_HISTORIES_LINK_TARGET,
    rel: AUDIT_HISTORIES_LINK_REL,
  };
}
